export default __webpack_public_path__ + "bb03a62546d778649dda892e18bac4c9.glb";